require("@rails/actiontext")
require("trix")

$(function() {
    $(document).on('trix-attachment-add', function(event) {
        let $trix_editor = $(event.target)
        if ($trix_editor.data('trix-editor-disable-images')) {
            event.preventDefault()
            return false;
        }
        return true;
    })

    // Add classes to the trix toolbar
    $(document).on('trix-initialize', function(event) {
        refreshTrixSettings();
    })

    refreshTrixSettings = function() {
        $('trix-editor').each( function() {
            let $trix_editor = $(this)
            let $trix_editor_toolbar = $('#' + $trix_editor.attr('toolbar'))
            $trix_editor_toolbar.attr('data-trix-editor-disable-images', $trix_editor.data('trix-editor-disable-images'))
            $trix_editor_toolbar.attr('data-trix-toolbar-simple-options', $trix_editor.data('trix-toolbar-simple-options'))
        })
    }
    refreshTrixSettings();
});